import React, { useState } from "react";
import { useFilters, Filters as ReactifyFilters, Filter } from "@usereactify/search";
import { FilterList } from "./filter-list";
import { FilterSlider } from "./filter-slider";

interface FilterProps {
  isSidePanel?: boolean;
}

export const Filters: React.FC<FilterProps> = ({ isSidePanel = false }) => {
  const { filters } = useFilters();
  const [openFilter, setopenFilter] = useState("");
  const onClick = (filterName: string) => {
    setopenFilter(filterName);
  };

  return (
    <div className={`filters__wrapper ${isSidePanel ? "side-panel-content" : ""}`}>
      <ReactifyFilters
        renderFilterList={(props) => (
          <FilterList filterListProps={props} isSidePanel={isSidePanel} onClick={onClick} openFilter={openFilter} />
        )}
        renderFilterSlider={(props) => <FilterSlider reactifyProps={props} onClick={onClick} openFilter={openFilter} />}
      />
    </div>
  );
};
